import React from "react";

import { Box } from "@mui/material";
import { getHours } from "date-fns";
import { makeStyles } from "tss-react/mui";

import GoodMorningIcon from "@/components/Icons/GoodMorningIcon";
import GoodAfternoonIcon from "@components/Icons/GoodAfternoonIcon";
import GoodEveningIcon from "@components/Icons/GoodEveningIcon";

import { Spacer } from "../Spacer/Spacer";
import { LargeTitle, LargeTitleBold } from "../Typography";

const useStyles = makeStyles()(() => ({
  iconSize: {
    height: "64px",
    width: "64px",
  },
}));

interface GreetingBannerProps {
  fullName: string;
}

export const GreetingBanner: React.FC<GreetingBannerProps> = ({ fullName }) => {
  const { classes } = useStyles();
  const hoursOfTheDay = getHours(new Date());

  const getGreetingData = (hoursOfTheDay: number) => {
    const greetings = {
      morning: {
        greetingMessage: "Good morning,",
        icon: <GoodMorningIcon className={classes.iconSize} />,
      },
      afternoon: {
        greetingMessage: "Good afternoon,",
        icon: <GoodAfternoonIcon className={classes.iconSize} />,
      },
      evening: {
        greetingMessage: "Good evening,",
        icon: <GoodEveningIcon className={classes.iconSize} />,
      },
    };

    if (hoursOfTheDay < 12) return greetings.morning;
    if (hoursOfTheDay < 18) return greetings.afternoon;
    return greetings.evening;
  };

  const { greetingMessage, icon } = getGreetingData(hoursOfTheDay);

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      {icon}
      <Spacer w={32} />
      <LargeTitle text={greetingMessage} />
      <Spacer w={8} />
      <LargeTitleBold text={fullName} />
    </Box>
  );
};
